import type { FighterState, FighterStateId } from "./state";

/** Смена состояния бойца: счётчик кадров состояния — с нуля. Отдельно, чтобы модули мира не цеплялись друг за друга. */
export function setState(fighter: FighterState, state: FighterStateId): void {
  fighter.state = state;
  fighter.stateFrame = 0;
}
